import React from 'react';
import {Table, Card, Button, Select, Typography, DatePicker, Tag, Modal, Space, Divider, Input} from "antd";
import {hs6pReport, hs6pReportList, visualize} from '../api/api'
import moment from "moment";

export const SubContractorSelect = ({value,onChange})=>{

    const [subcontractor, setSubcontractor] = React.useState([])

    const load = async ()=>{
        const {data:{rows = []}} = await visualize('hs6p_subcontractor')
        setSubcontractor(rows.map(({id, name})=>({id,name})))
    }

    React.useEffect(()=>{
        load();
    },[])

    return <React.Fragment>
        <Select showSearch optionFilterProp={'children'} placeholder="Select a subcontractor" style={{width: 400}} key={subcontractor} onChange={onChange} value={value}>
            {
                subcontractor.map(({id,name})=><Select.Option key={id} value={id}>{name}</Select.Option>)
            }
        </Select>
    </React.Fragment>
}


export const HS6PReportView = (props)=>{

    const [subcontractor,setSubcontractor] = React.useState()
    const [source, setSource] = React.useState([]);

    const load = async ()=>{
        if(subcontractor) {
            const {data:{rows=[]}} = await hs6pReportList(subcontractor)
            setSource(rows)
        }else
            setSource([])
    }

    React.useEffect(()=>{
        load();
    },[subcontractor])

    return <React.Fragment>
        <Card
            title={<SubContractorSelect value={subcontractor} onChange={e=>setSubcontractor(e)}/>}
        >
            <Table
                dataSource={source}
                pagination={false}
                size={`small`}
            >

                <Table.Column dataIndex={'id'} title={'Subcontractor Report'} render={(value, row, index) => {

                    const { id, hs6p_subcontractor_id } = row;
                    return <Space key={index}>
                        <Button disabled={false} onClick={async () => {
                            await hs6pReport(hs6p_subcontractor_id, id)
                        }}>Download</Button>
                    </Space>;
                }} />
                <Table.Column dataIndex={'duration'} title={'Duration'} render={(value,row,index)=>{
                    const { from_date, to_date } = row;
                    return <Typography.Text>{`${from_date} - ${to_date}`}</Typography.Text>
                }}/>

            </Table>
        </Card>
    </React.Fragment>
}